import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './tooltip.scss';

const Tooltip = ({ children, style, placement, theme = {} }) => {
  const containerClassName = classNames(styles.container, theme.container, {
    [styles[placement]]: placement,
  });
  const containerStyle = {
    ...style,
    ...theme.containerStyle,
  };

  return (
    <div className={containerClassName} style={containerStyle}>
      <div className={styles.content}>
        {children}
      </div>
      <div className={styles.triangleWrapper}>
        <div className={classNames(styles.triangle, theme.triangle)}/>
      </div>
    </div>
  );
};

Tooltip.propTypes = {
  children: PropTypes.node,
  style: PropTypes.object,
  placement: PropTypes.string,
  theme: PropTypes.object,
};

export default Tooltip;



// WEBPACK FOOTER //
// ./app/components/text-editor/tooltip.js